/**
 * DF overlay contract for the SDMS sheet — the type + key builder ONLY.
 *
 * Deliberately its own tiny module: `SdmsUniverSheet` is LAZY-loaded (it pulls in
 * Univer, a multi-hundred-kB chunk), and `SdmsPackageDetail` needs `dfOverlayKey`
 * to BUILD the map eagerly. Importing the helper from the sheet component would
 * make that lazy chunk a static dependency of the detail page and land Univer in
 * the main bundle. Keeping the contract here costs nothing at runtime.
 *
 * WHY THE OVERLAY EXISTS (client decision 2026-08-17, option A). The SDMS sheet's
 * column labelled "DF" is the DILUTION merge field — the template carries header
 * `M1 = "DF"` over `M9 = FIELD("DILUTION")` — so what LIMS renders there is
 * SpreadSheetEntry_SampleInfo.Dilution, re-merged whenever its SDMS screen
 * Retrieves. Our viewer loads the SAVED workbook, in which the INSTRUMENT raw-data
 * import has since overwritten that cell per ANALYTE row with the instrument's own
 * dilution — and an internal standard runs at 1x. Measured on QB26080509_042: 52 of
 * 56 rows already agree; all four differences are the ISTD row of a diluted sample
 * (blob 1, Dilution 2). Overlaying the bound field makes the sheet match LIMS.
 * Only the DF column is touched — every other cell renders the workbook verbatim.
 */

/** DF by row, keyed with {@link dfOverlayKey}. */
export type SdmsDfOverlay = ReadonlyMap<string, string>;

/** Canonical key — `"<syssamplecode>|<parameter>"`, lower-cased with whitespace
 *  collapsed. Use for BOTH sides of the lookup so the sheet's cell text and the
 *  API row match regardless of spacing/case. */
export const dfOverlayKey = (
  sys: string | null | undefined,
  parameter: string | null | undefined,
): string =>
  `${(sys ?? '').replace(/\s+/g, ' ').trim().toLowerCase()}|${(parameter ?? '').replace(/\s+/g, ' ').trim().toLowerCase()}`;
